import { Component, Input, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { OnDestroy } from '@angular/core';
import { ComponentBase } from 'src/app/views/component-base';
import { AppState } from 'src/app/store/app.states';
import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { InsuranceDetailsModel } from 'src/app/model/insurance-details.model';
import { commomState_SystemConfig_Config } from 'src/app/store/common/common.selectors';
import { MatIcon } from '@angular/material/icon';
import { MessagePipe } from '../../pipes/message';
import { BannerComponent } from '../banner/banner.component';

@Component({
  selector: 'app-no-insurance',
  templateUrl: './no-insurance.component.html',
  styleUrls: ['./no-insurance.component.scss'],
  imports: [NgFor, NgIf, MatIcon, AsyncPipe, MessagePipe, BannerComponent
  ],
})
export class NoInsuranceComponent
  extends ComponentBase
  implements OnInit, OnDestroy {

  @Input() fund = '';
  @Input() data?: InsuranceDetailsModel = undefined;
  
  bannerText:string = '';

  tenantConfig$ = this.appstore.pipe(select(commomState_SystemConfig_Config));
  constructor(public appstore: Store<AppState>) {
    super();
  }

  ngOnInit() {
    super.ngOnInitBase();
    this.sub = this.tenantConfig$.subscribe(x => {
      if (x){
        this.bannerText = `<p>You currently do not hold insurance with ${x?.name}.</p>`
      }
    })
  }

  ngOnDestroy() {
    super.ngOnDestroyBase();
  }
}
